<template>
    <div >
        <v-col cols="3" class="d-flex justify-begin mb-2">
                <v-btn class="mx-2 gris_medio" @click="exportToCSV">
                <span class="material-symbols-outlined">arrow_outward</span>   {{$t('general.exportar')}}
                </v-btn>
            </v-col>
        <div class="contenedor-tabla">
            <div class="scroll-container">
                <table>
                    <!-- <caption class="table-header">Senda de {{ this.$t('tabs.gas_precios_mibgas') }}</caption> -->
                    <thead>
                    <tr>
                        <th class="encabezado" >{{ this.$t('gas.horizonte') }}</th>
                        <th class="encabezado" >{{ this.$t('gas.hora') }}</th>
                        <th class="encabezado" >{{ this.$t('tabs.gas_precio_titulo') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(registro, index) in gas_mibgas" :key="index" class="tabla-hover">
                        <td class="primera_columna">{{ registro.fecha_hora }}</td>
                        <td class="primera_columna " style="text-align: center !important;">{{ registro.hora }}</td>
                        <td>
                    {{ (registro.valor !== null && registro.valor !== undefined) 
                          ? Number(registro.valor).toLocaleString('es-ES', { minimumFractionDigits: 2 }) 
                          : "" 
                    }}
                  </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <v-dialog v-model="showAlert" max-width="400">
                <v-card>
                    <v-card-title class="headline">{{$t('simulaciones.advertencia')}}</v-card-title>
                    <v-card-text>
                    {{ error_msg }}
                    </v-card-text>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="showAlert = false">{{$t('simulaciones.cerrar')}}</v-btn>
                    </v-card-actions>
                </v-card>
        </v-dialog>
    </div>
</template>

<script>

//imports
export default{
   props:{
    gas_mibgas:{
        type:Array,
        required:true,
    },
    horizonte:{
        type:Number,
        required:true,
    },
    horizonte_horas:{
        type:Number,
        required:true,
    }
   },
   components:{


   },
   computed:{
    precioMercado(){
        return [...this.gas_mibgas]
    }
   },
   data(){
       return{

            showAlert:false,

           hoursList:[],
           //precioMercado : [...this.gas_mibgas],
               columns:[
               { name: "Horizonte", prop: "fecha_hora", size: 150, readonly:true },
               { name: "Hora", prop: "hora", size: 150, readonly:true },
               {name: this.$t("tabs.gas_precio_titulo"), prop:"valor",size:200},
               
                   ],
       }
   },
   created(){
       //this.crearColumnas(7);
   },
   watch:{
    precioMercado:{
        handler(){
            /* const newArray = [...this.precioMercado];
            this.$emit('update:elec_manual', newArray); */
        },
        deep:true,
    },
   },

   methods:{
    toCsvDecimalComma(v, fixed = 2) {
        if (v === null || v === undefined || v === '') return '';
        let n = Number(v);
        if (Number.isNaN(n)) n = Number(String(v).replace(',', '.')); 
        if (Number.isNaN(n)) return '';
        return n.toLocaleString('es-ES', {
        minimumFractionDigits: fixed,
        maximumFractionDigits: fixed,
        useGrouping: false, 
        });
    },
        exportToCSV() {
            const headers = this.columns.map((col) => col.name).join(";");

            
            const rows = (this.precioMercado || [])
            .slice(0, this.horizonte_horas)
            .map((row) =>
                this.columns.map((col) => {
                const val = row[col.prop];
                if (val === undefined || val === null) return "";
              
                return col.prop === "valor" ? this.toCsvDecimalComma(val, 2) : String(val);
                }).join(";")
            );

            const csvContent = [headers, ...rows].join("\n");
            const BOM = "\uFEFF";
            const blob = new Blob([BOM + csvContent], { type: "text/csv;charset=utf-8;" });
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "precios_MIBGAS.csv";
            a.click();
            URL.revokeObjectURL(url);
        },

       crearColumnas(dias){
            const currentDate = new Date();

            // Sumar un día a la fecha actual
            currentDate.setDate(currentDate.getDate() + 1);
            

            // Generar la columna con las horas
             this.hoursList = [];
            for (let day=0; day<dias;day++){
                const newDate = new Date(currentDate);
                newDate.setDate(currentDate.getDate() + day);
                const formattedDate = newDate.toLocaleDateString('en-GB').replace(/\//g, '-'); // Formato 28-01-25
        
                for (let i = 0; i < 24; i++) {
                    const hour = i.toString().padStart(2, '0'); // Asegura que la hora tenga 2 dígitos
                    this.hoursList.push(`${formattedDate} ${hour}:00`);
                    this.matrixData.push({
                        horizonte:`${formattedDate} ${hour}:00`,
                        
                        precioMibgas:this.precioMercado[i+(24*day)],
                    })
                }
            }
            //console.log(hoursList);
       },
       handleCellEdit(event){
           console.log("Intercepta...");
           if (!event || !event.detail) {
               console.error("El evento o el detalle no están definidos correctamente.");
               return;
           }
           // Acceder al detalle del evento
           const { detail } = event;

           // Convertir a número si la columna es "valor"
           //if (detail.prop === "valor") { //Todas las columnas son numeros
           
           let newValue = Number(detail.val);
           let newValueSTR = String(detail.val).replace(',', '.'); // Reemplaza la coma por punto
           newValue = isNaN(newValueSTR) ? null : Number(newValueSTR); // Convierte a número o asigna null si no es válido
           console.log("newValue : ",newValue, " ", typeof(newValue));
           if (typeof(newValue)!=="number"){
           //alert("Introduzca solo datos numéricos");
           this.showAlert=true;
           }
           // Actualizar el modelo de la fila correspondiente
           const rowIndex = detail.rowIndex;
           this.matrixData[rowIndex][detail.prop] = newValue;
           // Confirmación en consola
           console.log(`Fila actualizada (${rowIndex}) (${detail.prop}):`, this.matrixData[rowIndex][detail.prop]);
       },
   },
}

</script>
<style scoped>
.contenedor-tabla {
  max-width: 600px;
  /* margin: auto; */
}
.scroll-container {
  width: 100%;
  height: 100%;
  max-height: calc(100vh - 200px); 
  overflow-x: auto;
  overflow-y: auto;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
}
table {
    width: 100%;
    border-collapse: collapse;
    text-align: center;
  }
  thead {
    position: sticky;
    top: 0;
    background-color: white;
    z-index: 10;
  }
  .table-header {
    position: sticky;
    top: 0;
    z-index: 15;
    font-size: 1.5em;
    font-weight: bold;
    text-align: center;
    margin-bottom: 10px;
    color: white;
    background-color: #006699;
    padding: 10px;
  }
  

  .primera_columna{
    background-color: white;
  }


  select {
    width: 100%;
    border: 1px solid #F2F2F2;
    border-radius: 4px;
    text-align: center;
    color: #024e74;
  }
  
.encabezado{
        font-size: 14px;
      }

</style>
